(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["crose-back-to-top"] && !Shopify.designMode) return;
  try {
    (() => {
    const button = document.querySelector('[data-crose-back-to-top]');
    if (!button) return;
    let pending = false;
    const update = () => {
      pending = false;
      const range = document.documentElement.scrollHeight - window.innerHeight;
      button.hidden = window.scrollY < 400;
      button.style.setProperty('--scroll-progress', range > 0 ? Math.min(100, Math.max(0, window.scrollY / range * 100)) : 0);
      const sticky = document.querySelector('product-sticky-form:not([hidden])');
      button.style.setProperty('--crose-bottom-offset', sticky && window.innerWidth < 1000 ? `${sticky.getBoundingClientRect().height}px` : '0px');
    };
    const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('pageshow', schedule);
    new ResizeObserver(schedule).observe(document.body);
    const sticky = document.querySelector('product-sticky-form');
    if (sticky) new MutationObserver(schedule).observe(sticky, { attributes: true, attributeFilter: ['hidden'] });
    button.addEventListener('click', () => {
      const main = document.getElementById('main');
      if (main) {
        if (!main.hasAttribute('tabindex')) { main.setAttribute('tabindex', '-1'); main.addEventListener('blur', () => main.removeAttribute('tabindex'), { once: true }); }
        main.focus({ preventScroll: true });
      }
      window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    });
    update();
  })();
  } catch(e) { console.error(e); }
})();

})();
